import React, { FC, ReactElement, ReactNode } from 'react';

import { NavigationButtonProps } from '../../components/NavigationButton';
import { classNames } from '../../utils/style';
import { PayFitColor } from '../../types/module';
import { applyBgColor } from '../../utils/utils';

export interface NavigationButtonsListProps {
  navigationButtons: Array<ReactElement<NavigationButtonProps>>;
  className?: string;
  backgroundColor?: PayFitColor;
  children?: ReactNode;
}

export const NavigationButtonsList: FC<NavigationButtonsListProps> = ({
  navigationButtons,
  className,
  backgroundColor,
  children,
}) => {
  return (
    <div
      className={classNames(
        'NavigationButtonsList',
        'flex sm:justify-center flex-col items-center',
        className ? className : '',
        applyBgColor(backgroundColor),
      )}
    >
      <div className="overflow-x-scroll sm:overflow-x-visible w-full">
        <div className="px-4 md:px-0 w-max sm:w-full m-auto">
          <nav
            className={classNames(
              'flex flex-nowrap sm:flex-wrap sm:justify-center px-12 md:px-24 lg:px-48 max-w-[1080px] mx-auto',
            )}
          >
            {navigationButtons}
          </nav>
        </div>
      </div>
      {children}
    </div>
  );
};
